import React from 'react'
import { MessageContent, BlockMessageItem } from '@/types/message'
import { observer } from 'mobx-react'
// import Card from '@/components/chat-card'
import avatar1 from '@/assets/images/avatar_1.svg'
import vector from '@/assets/images/vector.svg'

interface BlockProps {
  children: React.ReactNode
  blockItem: BlockMessageItem
  msgContent: MessageContent
  blockNodeRendered?: boolean
  style?: React.CSSProperties
  index: number
}

const Block: React.FC<BlockProps> = props => {
  const { msgContent, blockItem, style } = props
  // const { styleType } = blockItem
  // const isCard = styleType === 'card'

  return (
    <div data-key="msg-block" className="y-border-red-500   y-flex y-flex-col" style={{ ...style }}>
      <>
        {msgContent.placement === 'start' && blockItem?.showAvatar ? (
          <div className="y-flex y-mb-12">
            <img src={vector} className="y-w-16 y-h-16 y-mr-3" alt="" />
            <img src={avatar1} style={{ width: '50px' }} />
          </div>
        ) : null}

        <div
          className="y-flex-1"
          style={{
            // maxWidth: 'calc(100% - 44px)',
            overflowWrap: 'break-word'
          }}
        >
          {props.children}
          {/* {isCard ? <Card>{props.children}</Card> : props.children} */}
        </div>
      </>
    </div>
  )
}

export default observer(Block)
